import { render, staticRenderFns } from "./FlexMessageEditor.vue?vue&type=template&id=a7d8b6e0&scoped=true&"
import script from "./FlexMessageEditor.vue?vue&type=script&lang=js&"
export * from "./FlexMessageEditor.vue?vue&type=script&lang=js&"
import style0 from "./FlexMessageEditor.vue?vue&type=style&index=0&id=a7d8b6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d8b6e0",
  null
  
)

export default component.exports